let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6YPoU")).then(() => parcelRequire('4YCoX'));